//#region src/utils/request-users-location.ts
async function requestUsersLocation(locationService) {
	return new Promise((resolve) => navigator.geolocation.getCurrentPosition(async (pos) => {
		const { locations } = await locationService.getLocationsByCoordinates(pos.coords);
		const geolocation = locations?.[0];
		resolve(geolocation);
	}, () => {
		resolve(void 0);
	}));
}

//#endregion
export { requestUsersLocation };